import { Component, ViewChild, OnInit, inject } from '@angular/core';
import { AccountManagementComponent } from '../../account-management.component';
import { environment } from 'src/environments/environment';
import { ClientDocumentRow, DocumentService } from 'src/app/services/document.service';
@Component({
    selector: 'app-acct-home',
    templateUrl: './acct-home.component.html',
    styleUrls: ['./acct-home.component.scss'],
    standalone: false
})
export class AcctHomeComponent implements OnInit {
  private documentService = inject(DocumentService);

  cols: any = [];
  moduleName='Account';
  records: ClientDocumentRow[] = [];
  url = '';
  releaseBrief = '';
  ddWatch = '';
  userGuide = '';
  @ViewChild('acct_mgmt') acct_mgmt !: AccountManagementComponent;


  ngOnInit(): void {
    this.url = environment.apiUrl +'assets/'
    this.cols = [
      { field: 'dd', header: 'DD Watch' },
      { field: 'rb', header: 'Release Brief' },
      { field: 'ug', header: 'User Guide' },
    ];
  }


  loadRecordsLazy(){
    this.documentService.loadDocuments().subscribe(
    (rows: ClientDocumentRow[])=>
      this.records = rows
    );
    
  }

  getField(rowData: ClientDocumentRow, field: keyof ClientDocumentRow){
    return rowData[field]
  }


}